import styled from '@emotion/styled'
import { theme } from '@hhgtech/hhg-components'
import { rem, SegmentedControl, SegmentedControlProps } from '@mantine/core'

export const StyledSegmentedControl = styled(
  SegmentedControl,
)<SegmentedControlProps>`
  .mantine-SegmentedControl-indicator {
    box-shadow: 0px 0px 1px 0px #0000000a/ 0px 0px 2px 0px #0000000f/ 0px 4px
      8px 0px #0000000a;
  }

  .mantine-SegmentedControl-control {
    border-radius: ${rem(8)};
    outline: none;
    [data-active] {
      color: ${theme.colors.primaryBase};

      &:hover {
        color: ${theme.colors.primaryHover};
      }
    }

    :not(:first-of-type) {
      border-width: 0;
    }
  }

  .mantine-SegmentedControl-label {
    padding: 0;
  }
`

export const StyledSegmentedControlItemIcon = styled.span`
  font-size: ${rem(20)};
  line-height: 0;
`

export const StyledSegmentedControlItem = styled.div`
  display: flex;
  gap: ${rem(8)};
  align-items: center;
  justify-content: center;
  padding-block: ${rem(6)};
  padding-inline: ${rem(12)};
  font-weight: 600;
  font-size: ${rem(14)};
  line-height: ${rem(20)};
`
